<app-card class="flex-basis-100 mb-12" *ngIf="hasMachinesInsuranceMetadata()">
  <div cardTitle i18n>Assurance Machines</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.machinesInsured !== null &&
            metadata?.machinesInsuranceMetadata?.machinesInsured !==
              undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.machinesInsured !==
            null &&
            originalMetadata?.machinesInsuranceMetadata?.machinesInsured !==
              undefined)
        "
      >
        <span class="card__label" i18n>Machines</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.machinesInsuranceMetadata.machinesInsured
                ) !==
                  getBooleanLabel(
                    metadata.machinesInsuranceMetadata.machinesInsured
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.machinesInsuranceMetadata.machinesInsured
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.machinesInsured
              ) !==
                getBooleanLabel(
                  metadata.machinesInsuranceMetadata.machinesInsured
                ) &&
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.machinesInsured
              ) !== null &&
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.machinesInsured
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.machinesInsured
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
            metadata?.machinesInsuranceMetadata?.complementaryCoverage !==
              null &&
            metadata?.machinesInsuranceMetadata?.complementaryCoverage !==
              undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.machinesInsured ===
            true &&
            originalMetadata?.machinesInsuranceMetadata
              ?.complementaryCoverage !== null &&
            originalMetadata?.machinesInsuranceMetadata
              ?.complementaryCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture complémentaire</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.machinesInsuranceMetadata
                    .complementaryCoverage
                ) !==
                  getBooleanLabel(
                    metadata.machinesInsuranceMetadata.complementaryCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.machinesInsuranceMetadata.complementaryCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.complementaryCoverage
              ) !==
                getBooleanLabel(
                  metadata.machinesInsuranceMetadata.complementaryCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.complementaryCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.complementaryCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.machinesInsuranceMetadata.complementaryCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
            metadata?.machinesInsuranceMetadata
              ?.undergroundInaccessibilityCoverage !== null &&
            metadata?.machinesInsuranceMetadata
              ?.undergroundInaccessibilityCoverage !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.machinesInsured ===
            true &&
            originalMetadata?.machinesInsuranceMetadata
              ?.undergroundInaccessibilityCoverage !== null &&
            originalMetadata?.machinesInsuranceMetadata
              ?.undergroundInaccessibilityCoverage !== undefined)
        "
      >
        <span class="card__label" i18n
          >Inaccessibilité en cas d'utilisation souterraine</span
        >
        <span class="card__value">{{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata
              .undergroundInaccessibilityCoverage
          )
        }}</span>
      </div>
    </div>
  </div>

  <!-- First Type Machine Coverage -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      !isObjectEmpty(
        metadata?.machinesInsuranceMetadata?.firstTypeMachineCoverage
      ) ||
      !isObjectEmpty(
        originalMetadata?.machinesInsuranceMetadata?.firstTypeMachineCoverage
      )
    "
  >
    <div cardTitle i18n>Couverture Machine Type 1</div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            metadata?.machinesInsuranceMetadata?.firstTypeMachineCoverage
              ?.inventory ||
            originalMetadata?.machinesInsuranceMetadata
              ?.firstTypeMachineCoverage?.inventory
          "
        >
          <span class="card__label" i18n>Inventaire des machines 1</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .firstTypeMachineCoverage.inventory !==
                    metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                      .inventory,
              }"
              >{{
                metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                  .inventory
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.inventory !==
                  metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                    .inventory &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.inventory !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.inventory !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.inventory
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.firstTypeMachineCoverage
              ?.cover !== null &&
              metadata?.machinesInsuranceMetadata?.firstTypeMachineCoverage
                ?.cover !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.firstTypeMachineCoverage?.cover !== null &&
              originalMetadata?.machinesInsuranceMetadata
                ?.firstTypeMachineCoverage?.cover !== undefined)
          "
        >
          <span class="card__label" i18n>Couvertures</span>
          <span class="card__value">{{
            getBusinessMachineCoverLabel(
              metadata.machinesInsuranceMetadata.firstTypeMachineCoverage.cover
            )
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            metadata?.machinesInsuranceMetadata?.firstTypeMachineCoverage
              ?.insuredSum !== undefined ||
            originalMetadata?.machinesInsuranceMetadata
              ?.firstTypeMachineCoverage?.insuredSum !== undefined
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .firstTypeMachineCoverage.insuredSum !==
                    metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.insuredSum !==
                  metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            metadata?.machinesInsuranceMetadata?.firstTypeMachineCoverage
              ?.deductible !== undefined ||
            originalMetadata?.machinesInsuranceMetadata
              ?.firstTypeMachineCoverage?.deductible !== undefined
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .firstTypeMachineCoverage.deductible !==
                    metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.deductible !==
                  metadata.machinesInsuranceMetadata.firstTypeMachineCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.deductible !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .firstTypeMachineCoverage.deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <!-- Second Type Machine Coverage -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      !isObjectEmpty(
        metadata?.machinesInsuranceMetadata?.secondTypeMachineCoverage
      ) ||
      !isObjectEmpty(
        originalMetadata?.machinesInsuranceMetadata?.secondTypeMachineCoverage
      )
    "
  >
    <div cardTitle i18n>Groupe de machines 2</div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            metadata?.machinesInsuranceMetadata?.secondTypeMachineCoverage
              ?.inventory ||
            originalMetadata?.machinesInsuranceMetadata
              ?.secondTypeMachineCoverage?.inventory
          "
        >
          <span class="card__label" i18n>Groupe de machines 2</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .secondTypeMachineCoverage.inventory !==
                    metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                      .inventory,
              }"
              >{{
                metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                  .inventory
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.inventory !==
                  metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                    .inventory &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.inventory !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.inventory !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.inventory
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.secondTypeMachineCoverage
              ?.cover !== null &&
              metadata?.machinesInsuranceMetadata?.secondTypeMachineCoverage
                ?.cover !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.secondTypeMachineCoverage?.cover !== null &&
              originalMetadata?.machinesInsuranceMetadata
                ?.secondTypeMachineCoverage?.cover !== undefined)
          "
        >
          <span class="card__label" i18n>Couverture</span>
          <span class="card__value">{{
            getBusinessMachineCoverLabel(
              metadata.machinesInsuranceMetadata.secondTypeMachineCoverage.cover
            )
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            metadata?.machinesInsuranceMetadata?.secondTypeMachineCoverage
              ?.insuredSum !== undefined ||
            originalMetadata?.machinesInsuranceMetadata
              ?.secondTypeMachineCoverage?.insuredSum !== undefined
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .secondTypeMachineCoverage.insuredSum !==
                    metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.insuredSum !==
                  metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            metadata?.machinesInsuranceMetadata?.secondTypeMachineCoverage
              ?.deductible !== undefined ||
            originalMetadata?.machinesInsuranceMetadata
              ?.secondTypeMachineCoverage?.deductible !== undefined
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .secondTypeMachineCoverage.deductible !==
                    metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.deductible !==
                  metadata.machinesInsuranceMetadata.secondTypeMachineCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.deductible !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .secondTypeMachineCoverage.deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <!-- Loss Coverage -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      !isObjectEmpty(metadata?.machinesInsuranceMetadata?.lossCoverage) ||
      !isObjectEmpty(originalMetadata?.machinesInsuranceMetadata?.lossCoverage)
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Perte d'exploitation</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.lossCoverage?.covered !==
            null &&
            metadata?.machinesInsuranceMetadata?.lossCoverage?.covered !==
              undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.lossCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.lossCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.lossCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.lossCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.lossCoverage
                ?.machinesGroup !== null &&
              metadata?.machinesInsuranceMetadata?.lossCoverage
                ?.machinesGroup !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.machinesGroup !== null &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.machinesGroup !== undefined)
          "
        >
          <span class="card__label" i18n>Groupe de machines</span>
          <span class="card__value">{{
            getBusinessMachineGroupLabel(
              metadata.machinesInsuranceMetadata.lossCoverage.machinesGroup
            )
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.lossCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.lossCoverage
                ?.waitingDelay !== null &&
              metadata?.machinesInsuranceMetadata?.lossCoverage
                ?.waitingDelay !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.waitingDelay !== null &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.waitingDelay !== undefined)
          "
        >
          <span class="card__label" i18n>Délai de carence</span>
          <span class="card__value">{{
            getBusinessWaitingDaysLabel(
              metadata.machinesInsuranceMetadata.lossCoverage.waitingDelay
            )
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.lossCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.lossCoverage
                ?.namedMachines) ||
            (originalMetadata?.machinesInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.namedMachines)
          "
        >
          <span class="card__label" i18n>Machines nominatives</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.lossCoverage
                    .namedMachines !==
                    metadata.machinesInsuranceMetadata.lossCoverage
                      .namedMachines,
              }"
              >{{
                metadata.machinesInsuranceMetadata.lossCoverage.namedMachines
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .namedMachines !==
                  metadata.machinesInsuranceMetadata.lossCoverage
                    .namedMachines &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .namedMachines !== null &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .namedMachines !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .namedMachines
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.lossCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.lossCoverage?.coverageIn) ||
            (originalMetadata?.machinesInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.coverageIn)
          "
        >
          <span class="card__label" i18n>Couverture en</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.lossCoverage
                    .coverageIn !==
                    metadata.machinesInsuranceMetadata.lossCoverage.coverageIn,
              }"
              >{{
                metadata.machinesInsuranceMetadata.lossCoverage.coverageIn
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .coverageIn !==
                  metadata.machinesInsuranceMetadata.lossCoverage.coverageIn &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .coverageIn !== null &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .coverageIn !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .coverageIn
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.lossCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.lossCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.lossCoverage
                    .insuredSum !==
                    metadata.machinesInsuranceMetadata.lossCoverage.insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.lossCoverage.insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .insuredSum !==
                  metadata.machinesInsuranceMetadata.lossCoverage.insuredSum &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.lossCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.lossCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.lossCoverage
                ?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.lossCoverage
                    .deductible !==
                    metadata.machinesInsuranceMetadata.lossCoverage.deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.lossCoverage.deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .deductible !==
                  metadata.machinesInsuranceMetadata.lossCoverage.deductible &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .deductible !== null &&
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.lossCoverage
                  .deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <!-- Basic Coverage Fields -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata?.additionalFeesCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata?.additionalFeesCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Frais supplémentaires</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.additionalFeesCoverage
            ?.covered !== null &&
            metadata?.machinesInsuranceMetadata?.additionalFeesCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.additionalFeesCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.additionalFeesCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.additionalFeesCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.additionalFeesCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.additionalFeesCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.additionalFeesCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.additionalFeesCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .additionalFeesCoverage.insuredSum !==
                    metadata.machinesInsuranceMetadata.additionalFeesCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.additionalFeesCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.insuredSum !==
                  metadata.machinesInsuranceMetadata.additionalFeesCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.additionalFeesCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.additionalFeesCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.additionalFeesCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.additionalFeesCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .additionalFeesCoverage.deductible !==
                    metadata.machinesInsuranceMetadata.additionalFeesCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.additionalFeesCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.deductible !==
                  metadata.machinesInsuranceMetadata.additionalFeesCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.deductible !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .additionalFeesCoverage.deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Outils et moules interchangeables</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.toolsMoldsCoverage?.covered !==
            null &&
            metadata?.machinesInsuranceMetadata?.toolsMoldsCoverage?.covered !==
              undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.toolsMoldsCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
                ?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                    .insuredSum !==
                    metadata.machinesInsuranceMetadata.toolsMoldsCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.toolsMoldsCoverage.insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .insuredSum !==
                  metadata.machinesInsuranceMetadata.toolsMoldsCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.toolsMoldsCoverage
                ?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                    .deductible !==
                    metadata.machinesInsuranceMetadata.toolsMoldsCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.toolsMoldsCoverage.deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .deductible !==
                  metadata.machinesInsuranceMetadata.toolsMoldsCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .deductible !== null &&
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.toolsMoldsCoverage
                  .deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata?.dataCarriersCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata?.dataCarriersCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n
        >Supports de données et frais de reconstitution d'informations</span
      >
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.dataCarriersCoverage
            ?.covered !== null &&
            metadata?.machinesInsuranceMetadata?.dataCarriersCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.dataCarriersCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.dataCarriersCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.dataCarriersCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.dataCarriersCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.dataCarriersCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.dataCarriersCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.dataCarriersCoverage
                ?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .dataCarriersCoverage.insuredSum !==
                    metadata.machinesInsuranceMetadata.dataCarriersCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .insuredSum !==
                  metadata.machinesInsuranceMetadata.dataCarriersCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.dataCarriersCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.dataCarriersCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.dataCarriersCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.dataCarriersCoverage
                ?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .dataCarriersCoverage.deductible !==
                    metadata.machinesInsuranceMetadata.dataCarriersCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .deductible !==
                  metadata.machinesInsuranceMetadata.dataCarriersCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .deductible !== null &&
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.dataCarriersCoverage
                  .deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Pièces de mobilier</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
            ?.covered !== null &&
            metadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.furniturePiecesCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.furniturePiecesCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.furniturePiecesCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .furniturePiecesCoverage.insuredSum !==
                    metadata.machinesInsuranceMetadata.furniturePiecesCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.furniturePiecesCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.insuredSum !==
                  metadata.machinesInsuranceMetadata.furniturePiecesCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.furniturePiecesCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.furniturePiecesCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.furniturePiecesCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .furniturePiecesCoverage.deductible !==
                    metadata.machinesInsuranceMetadata.furniturePiecesCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.furniturePiecesCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.deductible !==
                  metadata.machinesInsuranceMetadata.furniturePiecesCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.deductible !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .furniturePiecesCoverage.deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata
            ?.additionalConstructionServicesCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata
            ?.additionalConstructionServicesCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n
        >Prestations supplémentaires de construction, frais de déblaiement</span
      >
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata
            ?.additionalConstructionServicesCoverage?.covered !== null &&
            metadata?.machinesInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered !==
              undefined) ||
          (originalMetadata?.machinesInsuranceMetadata
            ?.additionalConstructionServicesCoverage?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata
              .additionalConstructionServicesCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              metadata?.machinesInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.insuredSum !==
                undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.machinesInsuranceMetadata
              .additionalConstructionServicesCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              metadata?.machinesInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.deductible !==
                undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.machinesInsuranceMetadata
              .additionalConstructionServicesCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata?.rescueCostsCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata?.rescueCostsCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n
        >Frais de sauvetage des passagers d'installation de transport</span
      >
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.rescueCostsCoverage?.covered !==
            null &&
            metadata?.machinesInsuranceMetadata?.rescueCostsCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.rescueCostsCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.rescueCostsCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.rescueCostsCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.rescueCostsCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.rescueCostsCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.rescueCostsCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.rescueCostsCoverage
                ?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                    .insuredSum !==
                    metadata.machinesInsuranceMetadata.rescueCostsCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .insuredSum !==
                  metadata.machinesInsuranceMetadata.rescueCostsCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.rescueCostsCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.rescueCostsCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.rescueCostsCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.rescueCostsCoverage
                ?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                    .deductible !==
                    metadata.machinesInsuranceMetadata.rescueCostsCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .deductible !==
                  metadata.machinesInsuranceMetadata.rescueCostsCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .deductible !== null &&
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.rescueCostsCoverage
                  .deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata
            ?.internalDisturbancesDamageCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata
            ?.internalDisturbancesDamageCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Dommages dus aux troubles intérieurs</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata
            ?.internalDisturbancesDamageCoverage?.covered !== null &&
            metadata?.machinesInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata
            ?.internalDisturbancesDamageCoverage?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata
              .internalDisturbancesDamageCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              metadata?.machinesInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.machinesInsuranceMetadata
              .internalDisturbancesDamageCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              metadata?.machinesInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.machinesInsuranceMetadata
              .internalDisturbancesDamageCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata?.fireNaturalDisasterCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata
            ?.fireNaturalDisasterCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n
        >Dommages dus à l'incendie, aux événements naturels sur les ITG</span
      >
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.fireNaturalDisasterCoverage
            ?.covered !== null &&
            metadata?.machinesInsuranceMetadata?.fireNaturalDisasterCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata
            ?.fireNaturalDisasterCoverage?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata
              ?.fireNaturalDisasterCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.fireNaturalDisasterCoverage
              .covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.fireNaturalDisasterCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.fireNaturalDisasterCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.fireNaturalDisasterCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.fireNaturalDisasterCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.machinesInsuranceMetadata.fireNaturalDisasterCoverage
              .insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.fireNaturalDisasterCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.fireNaturalDisasterCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.fireNaturalDisasterCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.fireNaturalDisasterCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.machinesInsuranceMetadata.fireNaturalDisasterCoverage
              .deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(metadata?.machinesInsuranceMetadata?.theftCoverage)) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata?.theftCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Dommages dus au vol pour les ITG</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.theftCoverage?.covered !==
            null &&
            metadata?.machinesInsuranceMetadata?.theftCoverage?.covered !==
              undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.theftCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.theftCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.theftCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.theftCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.theftCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.theftCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.theftCoverage
                ?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.theftCoverage
                    .insuredSum !==
                    metadata.machinesInsuranceMetadata.theftCoverage.insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.theftCoverage.insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .insuredSum !==
                  metadata.machinesInsuranceMetadata.theftCoverage.insuredSum &&
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.theftCoverage?.covered ===
              true &&
              metadata?.machinesInsuranceMetadata?.theftCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.machinesInsuranceMetadata?.theftCoverage
              ?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata?.theftCoverage
                ?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata.theftCoverage
                    .deductible !==
                    metadata.machinesInsuranceMetadata.theftCoverage.deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.theftCoverage.deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .deductible !==
                  metadata.machinesInsuranceMetadata.theftCoverage.deductible &&
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .deductible !== null &&
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata.theftCoverage
                  .deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          metadata?.machinesInsuranceMetadata?.replacementCostCoverage
        )) ||
      (originalMetadata?.machinesInsuranceMetadata?.machinesInsured === true &&
        !isObjectEmpty(
          originalMetadata?.machinesInsuranceMetadata?.replacementCostCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Indemnisation à la valeur à neuf</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.machinesInsuranceMetadata?.replacementCostCoverage
            ?.covered !== null &&
            metadata?.machinesInsuranceMetadata?.replacementCostCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.machinesInsuranceMetadata?.replacementCostCoverage
            ?.covered !== null &&
            originalMetadata?.machinesInsuranceMetadata?.replacementCostCoverage
              ?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.machinesInsuranceMetadata.replacementCostCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.replacementCostCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.replacementCostCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.replacementCostCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.replacementCostCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .replacementCostCoverage.insuredSum !==
                    metadata.machinesInsuranceMetadata.replacementCostCoverage
                      .insuredSum,
              }"
              >{{
                metadata.machinesInsuranceMetadata.replacementCostCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.insuredSum !==
                  metadata.machinesInsuranceMetadata.replacementCostCoverage
                    .insuredSum &&
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.insuredSum !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.insuredSum !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.machinesInsuranceMetadata?.replacementCostCoverage
              ?.covered === true &&
              metadata?.machinesInsuranceMetadata?.replacementCostCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.machinesInsuranceMetadata
              ?.replacementCostCoverage?.covered === true &&
              originalMetadata?.machinesInsuranceMetadata
                ?.replacementCostCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.machinesInsuranceMetadata
                    .replacementCostCoverage.deductible !==
                    metadata.machinesInsuranceMetadata.replacementCostCoverage
                      .deductible,
              }"
              >{{
                metadata.machinesInsuranceMetadata.replacementCostCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.deductible !==
                  metadata.machinesInsuranceMetadata.replacementCostCoverage
                    .deductible &&
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.deductible !== null &&
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.deductible !== undefined
              "
              >{{
                originalMetadata.machinesInsuranceMetadata
                  .replacementCostCoverage.deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="hasTechnicalInstallationInsuranceMetadata()"
>
  <div cardTitle i18n>Assurance Installations Techniques</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationsInsured !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationsInsured !== undefined)
        "
      >
        <span class="card__label" i18n>Technique</span>
        <span class="card__value">{{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .technicalInstallationsInsured
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.complementaryCoverage !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.complementaryCoverage !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.complementaryCoverage !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.complementaryCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture complémentaire</span>
        <span class="card__value">{{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .complementaryCoverage
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            metadata?.technicalInstallationInsuranceMetadata?.cyberCoverage !==
              null &&
            metadata?.technicalInstallationInsuranceMetadata?.cyberCoverage !==
              undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.cyberCoverage !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.cyberCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture cyber</span>
        <span class="card__value">{{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata.cyberCoverage
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.fireNaturalDisasterCoverageExcluded !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.fireNaturalDisasterCoverageExcluded !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.fireNaturalDisasterCoverageExcluded !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.fireNaturalDisasterCoverageExcluded !== undefined)
        "
      >
        <span class="card__label" i18n
          >Exclusions des dommages dus à l'incendie, aux événements
          naturels</span
        >
        <span class="card__value">{{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .fireNaturalDisasterCoverageExcluded
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.theftDamagesExcluded !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.theftDamagesExcluded !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.theftDamagesExcluded !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.theftDamagesExcluded !== undefined)
        "
      >
        <span class="card__label" i18n>Exclusions des dommages dus au vol</span>
        <span class="card__value">{{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata.theftDamagesExcluded
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.waterDamagesExcluded !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.waterDamagesExcluded !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationsInsured === true &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.waterDamagesExcluded !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.waterDamagesExcluded !== undefined)
        "
      >
        <span class="card__label" i18n
          >Exclusions des dommages en dégats d'eau</span
        >
        <span class="card__value">{{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata.waterDamagesExcluded
          )
        }}</span>
      </div>
    </div>
  </div>

  <!-- Computer Objects Coverage -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Couverture Objets Informatiques</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.insuredSum !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance (CHF)</span>
          <span class="card__value"
            >{{
              metadata.technicalInstallationInsuranceMetadata
                .computerObjectsCoverage.insuredSum
            }}
            CHF</span
          >
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.deductible !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise (CHF)</span>
          <span class="card__value"
            >{{
              metadata.technicalInstallationInsuranceMetadata
                .computerObjectsCoverage.deductible
            }}
            CHF</span
          >
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.inventory) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.inventory)
          "
        >
          <span class="card__label" i18n>Inventaire</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsCoverage.inventory
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.replacementCostCoverage !== null &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.replacementCostCoverage !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.replacementCostCoverage !== null &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.replacementCostCoverage !==
                undefined)
          "
        >
          <span class="card__label" i18n>Couverture coût de remplacement</span>
          <span class="card__value">{{
            getBooleanLabel(
              metadata.technicalInstallationInsuranceMetadata
                .computerObjectsCoverage.replacementCostCoverage
            )
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.internalOperatingDamageCoverage !==
                null &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.internalOperatingDamageCoverage !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.internalOperatingDamageCoverage !==
                null &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsCoverage?.internalOperatingDamageCoverage !==
                undefined)
          "
        >
          <span class="card__label" i18n
            >Dommages dus aux perturbations de fonctionnement intérieures</span
          >
          <span class="card__value">{{
            getBooleanLabel(
              metadata.technicalInstallationInsuranceMetadata
                .computerObjectsCoverage.internalOperatingDamageCoverage
            )
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <!-- Technical Installation Coverage -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Couverture Installation Technique</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.technicalInstallationCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .technicalInstallationCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.insuredSum !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .technicalInstallationCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.deductible !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .technicalInstallationCoverage.deductible
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.inventory) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.inventory)
          "
        >
          <span class="card__label" i18n>Inventaire des ITG 1</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .technicalInstallationCoverage.inventory
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.replacementCostCoverage !==
                null &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.replacementCostCoverage !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.replacementCostCoverage !==
                null &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage?.replacementCostCoverage !==
                undefined)
          "
        >
          <span class="card__label" i18n>Couverture en valeur à neuf</span>
          <span class="card__value">{{
            getBooleanLabel(
              metadata.technicalInstallationInsuranceMetadata
                .technicalInstallationCoverage.replacementCostCoverage
            )
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage
                ?.internalOperatingDamageCoverage !== null &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage
                ?.internalOperatingDamageCoverage !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.technicalInstallationCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage
                ?.internalOperatingDamageCoverage !== null &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.technicalInstallationCoverage
                ?.internalOperatingDamageCoverage !== undefined)
          "
        >
          <span class="card__label" i18n
            >Couverture des dommages d'exploitation internes</span
          >
          <span class="card__value">{{
            getBooleanLabel(
              metadata.technicalInstallationInsuranceMetadata
                .technicalInstallationCoverage.internalOperatingDamageCoverage
            )
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <!-- Basic Coverage Fields for Technical Installation -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata?.dataCarriersCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.dataCarriersCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n
        >Supports de données et frais de reconstitution d'informations</span
      >
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.dataCarriersCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.dataCarriersCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.dataCarriersCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.dataCarriersCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata.dataCarriersCoverage
              .covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.dataCarriersCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.dataCarriersCoverage?.insuredSum !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.dataCarriersCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.dataCarriersCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata.dataCarriersCoverage
              .insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.dataCarriersCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.dataCarriersCoverage?.deductible !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.dataCarriersCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.dataCarriersCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata.dataCarriersCoverage
              .deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInSwitzerlandCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInSwitzerlandCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Objets informatiques en circulation en Suisse/FL</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInSwitzerlandCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInSwitzerlandCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInSwitzerlandCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInSwitzerlandCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsInSwitzerlandCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInSwitzerlandCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInSwitzerlandCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInSwitzerlandCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInSwitzerlandCoverage?.insuredSum !==
                undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsInSwitzerlandCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInSwitzerlandCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInSwitzerlandCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInSwitzerlandCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInSwitzerlandCoverage?.deductible !==
                undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsInSwitzerlandCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInternationalCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInternationalCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Objets informatiques dans le monde entier</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInternationalCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInternationalCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsInternationalCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInternationalCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsInternationalCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInternationalCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInternationalCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInternationalCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInternationalCoverage?.insuredSum !==
                undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsInternationalCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInternationalCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInternationalCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsInternationalCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsInternationalCoverage?.deductible !==
                undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsInternationalCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata?.wiringCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.wiringCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Câblage (si non compris dans l'assurance de base)</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata?.wiringCoverage
            ?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata?.wiringCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.wiringCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.wiringCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata.wiringCoverage
              .covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.wiringCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.wiringCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.wiringCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.wiringCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata.wiringCoverage
              .insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.wiringCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.wiringCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.wiringCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.wiringCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata.wiringCoverage
              .deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.additionalConstructionServicesCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.additionalConstructionServicesCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n
        >Prestations supplémentaires de construction, frais de déblaiement</span
      >
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.additionalConstructionServicesCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered !==
              undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.additionalConstructionServicesCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .additionalConstructionServicesCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.insuredSum !==
                undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .additionalConstructionServicesCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.additionalConstructionServicesCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.additionalConstructionServicesCoverage?.deductible !==
                undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .additionalConstructionServicesCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsAdditionalFeesCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsAdditionalFeesCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Frais supplémentaires pour objets informatiques</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsAdditionalFeesCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsAdditionalFeesCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.computerObjectsAdditionalFeesCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsAdditionalFeesCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsAdditionalFeesCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsAdditionalFeesCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsAdditionalFeesCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsAdditionalFeesCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsAdditionalFeesCoverage?.insuredSum !==
                undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsAdditionalFeesCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsAdditionalFeesCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsAdditionalFeesCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.computerObjectsAdditionalFeesCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.computerObjectsAdditionalFeesCoverage?.deductible !==
                undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .computerObjectsAdditionalFeesCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.internalDisturbancesDamageCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.internalDisturbancesDamageCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Dommages dus aux troubles intérieurs</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.internalDisturbancesDamageCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.internalDisturbancesDamageCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .internalDisturbancesDamageCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .internalDisturbancesDamageCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.internalDisturbancesDamageCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.internalDisturbancesDamageCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .internalDisturbancesDamageCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata
            ?.undergroundInaccessibilityCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.undergroundInaccessibilityCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Inaccessibilité en cas d'utilisation souterraine</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata
            ?.undergroundInaccessibilityCoverage?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata
              ?.undergroundInaccessibilityCoverage?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.undergroundInaccessibilityCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.undergroundInaccessibilityCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata
              .undergroundInaccessibilityCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.undergroundInaccessibilityCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.undergroundInaccessibilityCoverage?.insuredSum !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.undergroundInaccessibilityCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.undergroundInaccessibilityCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .undergroundInaccessibilityCoverage.insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata
              ?.undergroundInaccessibilityCoverage?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata
                ?.undergroundInaccessibilityCoverage?.deductible !==
                undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.undergroundInaccessibilityCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.undergroundInaccessibilityCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata
              .undergroundInaccessibilityCoverage.deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata?.theftCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata
            ?.theftCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Dommages dus au vol pour les ITG</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata?.theftCoverage
            ?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata?.theftCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.theftCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.theftCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata.theftCoverage
              .covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.theftCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.theftCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.theftCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.theftCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata.theftCoverage
              .insuredSum
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.theftCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.theftCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.theftCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.theftCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <span class="card__value">{{
            metadata.technicalInstallationInsuranceMetadata.theftCoverage
              .deductible
          }}</span>
        </div>
      </div>
    </div>
  </app-card>

  <!-- Technical Installation Loss Coverage -->
  <app-card
    class="flex-basis-100 mt-3"
    *ngIf="
      (metadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
        )) ||
      (originalMetadata?.technicalInstallationInsuranceMetadata
        ?.technicalInstallationsInsured === true &&
        !isObjectEmpty(
          originalMetadata?.technicalInstallationInsuranceMetadata?.lossCoverage
        ))
    "
  >
    <div cardTitle class="d-flex">
      <span i18n>Perte d'exploitation</span>
      <span
        class="ms-auto"
        *ngIf="
          (metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
            ?.covered !== null &&
            metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
              ?.covered !== undefined) ||
          (originalMetadata?.technicalInstallationInsuranceMetadata
            ?.lossCoverage?.covered !== null &&
            originalMetadata?.technicalInstallationInsuranceMetadata
              ?.lossCoverage?.covered !== undefined)
        "
      >
        {{
          getBooleanLabel(
            metadata.technicalInstallationInsuranceMetadata.lossCoverage.covered
          )
        }}
      </span>
    </div>
    <div cardRows class="card__rows w-100">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
                ?.waitingDelay !== null &&
              metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
                ?.waitingDelay !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.lossCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.lossCoverage?.waitingDelay !== null &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.lossCoverage?.waitingDelay !== undefined)
          "
        >
          <span class="card__label" i18n>Délai de carence</span>
          <span class="card__value">{{
            getBusinessWaitingDaysLabel(
              metadata.technicalInstallationInsuranceMetadata.lossCoverage
                .waitingDelay
            )
          }}</span>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
                ?.coverageIn) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.lossCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.lossCoverage?.coverageIn)
          "
        >
          <span class="card__label" i18n>Couverture en</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.technicalInstallationInsuranceMetadata
                    .lossCoverage.coverageIn !==
                    metadata.technicalInstallationInsuranceMetadata.lossCoverage
                      .coverageIn,
              }"
              >{{
                metadata.technicalInstallationInsuranceMetadata.lossCoverage
                  .coverageIn
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.coverageIn !==
                  metadata.technicalInstallationInsuranceMetadata.lossCoverage
                    .coverageIn &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.coverageIn !== null &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.coverageIn !== undefined
              "
              >{{
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.coverageIn
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
                ?.insuredSum !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.lossCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.lossCoverage?.insuredSum !== undefined)
          "
        >
          <span class="card__label" i18n>Somme d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.technicalInstallationInsuranceMetadata
                    .lossCoverage.insuredSum !==
                    metadata.technicalInstallationInsuranceMetadata.lossCoverage
                      .insuredSum,
              }"
              >{{
                metadata.technicalInstallationInsuranceMetadata.lossCoverage
                  .insuredSum
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.insuredSum !==
                  metadata.technicalInstallationInsuranceMetadata.lossCoverage
                    .insuredSum &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.insuredSum !== null &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.insuredSum !== undefined
              "
              >{{
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.insuredSum
              }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
              ?.covered === true &&
              metadata?.technicalInstallationInsuranceMetadata?.lossCoverage
                ?.deductible !== undefined) ||
            (originalMetadata?.technicalInstallationInsuranceMetadata
              ?.lossCoverage?.covered === true &&
              originalMetadata?.technicalInstallationInsuranceMetadata
                ?.lossCoverage?.deductible !== undefined)
          "
        >
          <span class="card__label" i18n>Franchise</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value':
                  originalMetadata &&
                  originalMetadata.technicalInstallationInsuranceMetadata
                    .lossCoverage.deductible !==
                    metadata.technicalInstallationInsuranceMetadata.lossCoverage
                      .deductible,
              }"
              >{{
                metadata.technicalInstallationInsuranceMetadata.lossCoverage
                  .deductible
              }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                originalMetadata &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.deductible !==
                  metadata.technicalInstallationInsuranceMetadata.lossCoverage
                    .deductible &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.deductible !== null &&
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.deductible !== undefined
              "
              >{{
                originalMetadata.technicalInstallationInsuranceMetadata
                  .lossCoverage.deductible
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </app-card>
</app-card>
